var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.customizations && _vm.item.customizations.length)?_c('div',{staticClass:"item-customizations small"},_vm._l((_vm.item.customizations),function(ref){
var _id = ref._id;
var label = ref.label;
var option = ref.option;
return _c('div',{key:("cs-" + _id)},[_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(label)+": ")]),_vm._v(" "+_vm._s(option.text)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }